"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testimonialsReducer = void 0;
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var states_init_1 = require("@/pages/testimonials/states/states.init");
var typesafe_actions_1 = require("typesafe-actions");
var actions_1 = require("@/pages/testimonials/actions/actions");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var RootPublicPageReducer_1 = require("@/pages/common/reducers/RootPublicPageReducer");
exports.testimonialsReducer = {
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.TESTIMONIALS; }
        return state;
    },
    agentOptions: function (state) {
        if (state === void 0) { state = states_init_1.defaultAgentOptions; }
        return state;
    },
    agentIdFilter: function (state) {
        if (state === void 0) { state = 0; }
        return state;
    },
    currentOrderBy: function (state) {
        if (state === void 0) { state = 2; }
        return state;
    },
    currentSortBy: function (state) {
        if (state === void 0) { state = 2; }
        return state;
    },
    pager: function (state) {
        if (state === void 0) { state = states_init_1.defaultPager; }
        return state;
    },
    t: function (state) {
        if (state === void 0) { state = states_init_1.defaultTranslations; }
        return state;
    },
    title: function (state) {
        if (state === void 0) { state = 'What Our Clients Say'; }
        return state;
    },
    testimonials: function (state) {
        if (state === void 0) { state = states_init_1.defaultTestimonials; }
        return state;
    },
    resultPageTranslation: function (state) {
        if (state === void 0) { state = ResultPageState_init_1.defaultResultPageState.t; }
        return state;
    },
};
var combinedReducer = redux_1.combineReducers(__assign(__assign({}, RootPublicPageReducer_1.default), exports.testimonialsReducer));
var rootTestimonialsReducer = function (state, action) {
    switch (action.type) {
        case typesafe_actions_1.getType(actions_1.default.reloadItems): {
            return __assign(__assign({}, state), { testimonials: { items: __spreadArrays(action.payload) } });
        }
        case typesafe_actions_1.getType(actions_1.default.reloadPager): {
            return __assign(__assign({}, state), { pager: __assign({}, action.payload) });
        }
        case typesafe_actions_1.getType(actions_1.default.setAgentIdFilter): {
            return __assign(__assign({}, state), { agentIdFilter: action.payload });
        }
        case 'SET_ALL_STATE_TESTIMONIALS': {
            return __assign(__assign({}, state), action.payload);
        }
        default:
            return combinedReducer(state, action);
    }
};
exports.default = rootTestimonialsReducer;
